module.exports = __webpack_public_path__ + "img/team-bg-t2.2fdb57c5.svg";